import {Link, Outlet, useLocation, Navigate} from 'react-router-dom'
import {useAuth} from '../context/AuthContext'
import {useAccount} from '../context/AccountContext'
import './MainLayout.css'

function MainLayout() {
    const location = useLocation()
    const {logout, user} = useAuth()
    const {selectedAccount, accounts, loading, error, isAdminUser} = useAccount()

    const isActive = (path: string): boolean => {
        return location.pathname === path
    }

    // Auto-redirect admin users to account settings if no account exists (but not if already on account-settings page)
    if (!loading && accounts.length === 0 && isAdminUser && location.pathname !== '/account-settings') {
        return <Navigate to="/account-settings" replace />
    }

    return (
        <div className="layout">
            <header className="top-nav">
                <div className="nav-content">
                    <Link to="/" className="nav-brand">
                        <span className="brand-name">
                            {!loading && (error || !selectedAccount ? (
                                <span className="no-account-warning">
                                    <span className="warning-icon" style={{fontWeight: 500, fontSize: '1.6rem'}}>&#9888;</span> Client account not found
                                </span>
                            ) : selectedAccount)}
                        </span>
                        {user && (
                            <span className="user-info">
                                {user.firstName} {user.lastName} ({user.userName})
                            </span>
                        )}
                    </Link>
                    <nav className="nav-links">
                        <Link to="/" className={`nav-link ${isActive('/') ? 'active' : ''}`}>
                            Releases and Versions
                        </Link>
                        <Link to="/proposal-rating" className={`nav-link ${isActive('/proposal-rating') ? 'active' : ''}`}>
                            Single Proposal Rating
                        </Link>
                        <Link to="/bulk-rating" className={`nav-link ${isActive('/bulk-rating') ? 'active' : ''}`}>
                            Bulk Proposal Rating
                        </Link>
                        {isAdminUser && (
                            <Link to="/account-settings" className={`nav-link ${isActive('/account-settings') ? 'active' : ''}`}>
                                Account Settings
                            </Link>
                        )}
                        <button onClick={logout} className="nav-link logout-btn">
                            Logout
                        </button>
                    </nav>
                </div>
            </header>

            <main className="content">
                <Outlet/>
            </main>
        </div>
    )
}

export default MainLayout
